import { defineStore } from "pinia";

export interface JobState {
  job_id: number;
  status_text: string;
}

export const useJobStore = defineStore("job", {
  state: (): JobState => ({
    job_id: 0,
    status_text: "",
  }),
  actions: {
    setJobId(jobId: number): void {
      this.job_id = jobId;
    },
    setStatusText(statusText: string): void {
      this.status_text = statusText;
    },
    updateJob(data: JobState): void {
      this.job_id = data.job_id;
      this.status_text = data.status_text;
    },
  },
});
